import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { FaLinkedin, FaFacebook, FaXTwitter } from 'react-icons/fa6';

const socialLinks = [
  { icon: <FaLinkedin />, key: 'linkedin', url: 'https://www.linkedin.com/' },
  { icon: <FaFacebook />, key: 'facebook', url: 'https://www.facebook.com/' },
  { icon: <FaXTwitter />, key: 'x', url: 'https://x.com/' },
];

const Footer = () => {
  const { language, direction } = useLanguage();
  return (
    <footer style={{ direction }} className="footer">
      <p style={{ color: 'var(--color-text)', fontWeight: 600, fontSize: '1.1em', marginBottom: 16 }}>
        © 2025 {language === 'ar' ? 'جميع الحقوق محفوظة - شركة ZoneCoder' : 'All Rights Reserved - ZoneCoder Company'}
      </p>
  
    </footer>
  );
};

export default Footer;